import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { About } from "./components/About";
import { Services } from "./components/Services";
import { ProcessReveal } from "./components/ProcessReveal";
import { Gallery } from "./components/Gallery";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { Splash } from "./components/Splash";
import { CookieBanner } from "./components/CookieBanner";
import { ContentProvider } from "./context/ContentContext";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import CookiePolicy from "./pages/CookiePolicy";

function HomePage() {
  return (
    <div className="App bg-paper">
      <Splash />
      <Navbar />
      <main>
        <Hero />
        <About />
        <Services />
        <ProcessReveal />
        <Gallery />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <ContentProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <CookieBanner />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/cookie" element={<CookiePolicy />} />
        </Routes>
      </BrowserRouter>
    </ContentProvider>
  );
}

export default App;
